import type { ReactNode } from 'react';
import { SchoolLogo, useSchoolSettings } from './SchoolSettings';

export function printSection(targetId:string, title?:string) {
  const target=document.getElementById(targetId);
  if(!target)return;
  document.querySelectorAll('.print-active').forEach(element=>element.classList.remove('print-active'));
  target.classList.add('print-active');
  const previousTitle=document.title;
  if(title)document.title=title;
  const cleanup=()=>{target.classList.remove('print-active');document.title=previousTitle;};
  window.addEventListener('afterprint',cleanup,{once:true});
  window.print();
}

export function PrintHeader({ title, subtitle, meta }: { title:string;subtitle?:string;meta?:ReactNode }) {
  const {settings}=useSchoolSettings();
  return <header className="print-header"><div className="print-brand"><span><SchoolLogo/></span><div><strong>{settings.school_name}</strong><small>{settings.registration_number?`Registration ${settings.registration_number}`:'School Management Suite'}</small></div></div><div className="print-title"><h1>{title}</h1>{subtitle&&<p>{subtitle}</p>}{meta&&<div>{meta}</div>}</div></header>;
}
